import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const TrafficLightList = ({ trafficLights, viewMode, onEdit, onControlSingle, onControlBatch, onDelete, error, searchTerm }) => {
  const [selectedLights, setSelectedLights] = useState([]);
  const [lightPositions, setLightPositions] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLightId, setSelectedLightId] = useState(null);
  const [newImageUrl, setNewImageUrl] = useState('');

  // Lấy vị trí từ API khi component mount
  useEffect(() => {
    const fetchPositions = async () => {
      try {
        console.log('Fetching positions from API...');
        const response = await fetch('https://trafficlight.saigoniot.vn/api/dpt/position', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log('Raw GET /api/dpt/position response:', JSON.stringify(result, null, 2));
        const normalizedData = result.data;
        if (result.status === 'success') {
          console.log('Processing lightPositions data:', JSON.stringify(result.data, null, 2));
          // Chuyển đổi chuỗi thành số, loại bỏ 'px' và xử lý fallback
          console.log('Normalized lightPositions:', JSON.stringify(normalizedData, null, 2));
          setLightPositions(normalizedData);
        } else {
          console.warn('No valid positions data from API:', result.message || 'No data');

          setLightPositions(normalizedData);
        }
      } catch (err) {
        console.error('Error fetching positions:', err.message);
        const staticData = {
          "1": { "1": [{ "top": 55.67, "left": 58.47 }], "2": [{ "top": 107.67, "left": 113.47 }], "intersectionImage": "https://trafficlight.saigoniot.vn/intersection.jpg" },
          "2": { "1": [{ "top": 4.67, "left": 126 }], "2": [{ "top": 104.67, "left": 166 }], "intersectionImage": "https://trafficlight.saigoniot.vn/0b4bd1a4560fe151b81e.jpg" },
          "3": { "5": [{ "top": 95.33, "left": 56 }], "6": [{ "top": 117.33, "left": 108 }], "7": [{ "top": 73.33, "left": 119 }], "8": [{ "top": 54.33, "left": 78 }], "intersectionImage": "https://trafficlight.saigoniot.vn/intersection.jpg" },
          "5": { "1": [{ "top": 49.33, "left": 66 }], "2": [{ "top": 95.33, "left": 58 }], "3": [{ "top": 118.33, "left": 106 }], "4": [{ "top": 68.33, "left": 114 }], "intersectionImage": "https://trafficlight.saigoniot.vn/intersection.jpg" },
          "7": { "1": [{ "top": 72.62, "left": 52.66 }], "2": [{ "top": 104, "left": 95.47 }, { "top": 60, "left": 90 }], "3": [{ "top": 84, "left": 141 }], "intersectionImage": "https://trafficlight.saigoniot.vn/3c0a8a02dea169ff30b0.jpg" },
          "8": { "1": [{ "top": 105, "left": 120.41 }], "2": [{ "top": 82, "left": 60.41 }], "intersectionImage": "https://trafficlight.saigoniot.vn/ae030ad26878df268669.jpg" },
          "9": { "1": [{ "top": 45, "left": 121 }], "intersectionImage": "https://trafficlight.saigoniot.vn/intersection.jpg" },
          "10": { "1": [{ "top": 53.62, "left": 159.81 }], "2": [{ "top": 112, "left": 114 }], "3": [{ "top": 100, "left": 122.41 }], "4": [{ "top": 74.62, "left": 44.81 }], "intersectionImage": "https://trafficlight.saigoniot.vn/d964f07de2de55800ccf.jpg" },
          "11": { "1": [{ "top": 110, "left": 72 }, { "top": 47, "left": 74 }], "2": [{ "top": 72, "left": 117 }], "intersectionImage": "https://trafficlight.saigoniot.vn/80ee179b113ba665ff2a.jpg" },
          "12": { "1": [{ "top": 46, "left": 112 }], "intersectionImage": "https://trafficlight.saigoniot.vn/intersection11.jpg" },
          "2551": { "1": [{ "top": 24.67, "left": 82 }], "2": [{ "top": 87.67, "left": 113 }], "intersectionImage": "https://trafficlight.saigoniot.vn/8b30f1b87b13cc4d9502.jpg" },
          "5547": { "1": [{ "top": 116.33, "left": 47.47 }], "2": [{ "top": 41.33, "left": 129.47 }], "intersectionImage": "https://trafficlight.saigoniot.vn/intersection.jpg" }
        };
        setLightPositions(staticData);
      }
    };
    fetchPositions();
  }, []);

  // Log full trafficLights data for debugging
  //console.log('trafficLights data:', JSON.stringify(trafficLights, null, 2));

  // Lọc và sắp xếp đèn: Online lên đầu, Offline ở dưới
  const filteredLights = trafficLights
    .filter((light) => (light.name || '').toLowerCase().includes((searchTerm || '').toLowerCase()))
    .map(light => ({
      ...light,
      intersectionImage: lightPositions[String(light.id)]?.intersectionImage || 'https://trafficlight.saigoniot.vn/intersection.jpg'
    }))
    .sort((a, b) => {
      if (a.onlineStatus === 'Online' && b.onlineStatus === 'Offline') return -1;
      if (a.onlineStatus === 'Offline' && b.onlineStatus === 'Online') return 1;
      return 0;
    });

  // Xử lý chọn/bỏ chọn đèn
  const handleSelectLight = (light) => {
    setSelectedLights((prev) =>
      prev.some((selected) => selected.id === light.id)
        ? prev.filter((selected) => selected.id !== light.id)
        : [...prev, light]
    );
  };

  // Xử lý điều khiển hàng loạt
  const handleBatchControl = async () => {
    if (selectedLights.length === 0) {
      alert('Vui lòng chọn ít nhất một đèn để điều khiển!');
      return;
    }
    try {
      const success = await onControlBatch(selectedLights);
      console.log('Batch control result:', success);
      setSelectedLights([]);
    } catch (err) {
      console.error('Lỗi khi điều khiển hàng loạt:', err);
      alert('Điều khiển không thành công. Vui lòng thử lại!');
    }
  };

  // Hàm xác định trạng thái màu cho từng kênh
  const getLightStatus = (light) => {
    console.log(`getLightStatus called with id: ${light.id}, currentPharse: ${light.currentPharse}, current_status: ${light.current_status}, activeChannel:`, JSON.stringify(light.activeChannel, null, 2));
    if (!light.activeChannel || !Array.isArray(light.activeChannel) || light.activeChannel.length === 0) {
      console.warn(`Invalid activeChannel for light ${light.id}:`, light.activeChannel);
      return [];
    }
    if (light.onlineStatus === 'Offline') {
      console.log(`Light ${light.id} is Offline, returning all channels as unknown`);
      return light.activeChannel.map(() => 'unknown');
    }
    if (!['green', 'yellow'].includes(light.current_status)) {
      console.warn(`Invalid color: ${light.current_status} for light ${light.id}, returning all channels red`);
      return light.activeChannel.map(() => 'red');
    }
    if (!light.currentPharse || light.currentPharse < 1) {
      console.warn(`Invalid currentPharse: ${light.currentPharse} for light ${light.id}, returning all channels red`);
      return light.activeChannel.map(() => 'red');
    }

    // Lấy danh sách channelNumber từ activeChannel
    const validChannelNumbers = new Set(light.activeChannel.map(channel => channel.channelNumber));
    console.log(`Valid channelNumbers for light ${light.id}:`, Array.from(validChannelNumbers));

    // Xác định trạng thái màu dựa trên currentPharse
    return light.activeChannel.map((channel) => {
      if (validChannelNumbers.has(light.currentPharse) && channel.channelNumber === light.currentPharse) {
        return light.current_status; // Màu hiện tại cho channel khớp với currentPharse
      }
      return 'red'; // Các channel khác là đỏ
    });
  };

  // Hàm lấy tên channel hiện tại
  const getCurrentChannelName = (light) => {
    if (!light.activeChannel || !Array.isArray(light.activeChannel) || light.activeChannel.length === 0) {
      return 'N/A';
    }
    const currentChannel = light.activeChannel.find(channel => channel.channelNumber === light.currentPharse);
    return currentChannel ? currentChannel.channelName : 'N/A';
  };

  // Định nghĩa mã màu hex
  const colorMap = {
    green: '#008000',
    yellow: '#FFA500',
    red: '#FF0000',
    unknown: '#808080',
  };

  // Khởi tạo vị trí mặc định hoặc từ lightPositions
  const getChannelPosition = (light, channel, cloneIndex = 0) => {
    const lightId = String(light.id);
    const channelNumber = String(channel.channelNumber);
    console.log(`getChannelPosition: lightId=${lightId}, channelNumber=${channelNumber}, cloneIndex=${cloneIndex}, lightPositions=`, JSON.stringify(lightPositions, null, 2));
    const positions = lightPositions[lightId]?.[channelNumber] || [];
    if (positions[cloneIndex]) {
      console.log(`Found custom position for lightId=${lightId}, channelNumber=${channelNumber}, cloneIndex=${cloneIndex}:`, positions[cloneIndex]);
      return { top: `${positions[cloneIndex].top}px`, left: `${positions[cloneIndex].left}px` };
    }
    if (channel.channelPosition) {
      console.log(`Using default position for lightId=${lightId}, channelNumber=${channelNumber}, channelPosition=${channel.channelPosition}`);
      switch (channel.channelPosition) {
        case 'north':
          return { top: '20px', left: '90px' };
        case 'south':
          return { top: '160px', left: '90px' };
        case 'east':
          return { top: '90px', left: '160px' };
        case 'west':
          return { top: '90px', left: '20px' };
        default:
          console.log(`No valid channelPosition for lightId=${lightId}, channelNumber=${channelNumber}, falling back to horizontal`);
          return { top: '90px', left: `${40 + (cloneIndex * 40)}px` };
      }
    }
    console.log(`No position data for lightId=${lightId}, channelNumber=${channelNumber}, falling back to horizontal`);
    return { top: '90px', left: `${40 + (cloneIndex * 40)}px` };
  };

  // Xử lý bắt đầu kéo
  const handleDragStart = (e, lightId, channelNumber, cloneIndex) => {
    console.log(`Drag start: lightId=${lightId}, channelNumber=${channelNumber}, cloneIndex=${cloneIndex}, ctrlKey=${e.ctrlKey}`);
    e.dataTransfer.setData('text/plain', JSON.stringify({ lightId, channelNumber, cloneIndex, isClone: e.ctrlKey }));
  };

  // Xử lý thả
  const handleDrop = async (e, lightId) => {
    e.preventDefault();
    console.log(`Drop event on lightId=${lightId}`);
    const data = JSON.parse(e.dataTransfer.getData('text/plain'));
    if (data.lightId !== lightId) {
      console.warn(`Invalid drop: lightId mismatch (dropped ${data.lightId} on ${lightId})`);
      return;
    }

    const container = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - container.left - 12;
    const y = e.clientY - container.top - 12;
    const boundedX = Math.max(0, Math.min(x, 188));
    const boundedY = Math.max(0, Math.min(y, 188));

    setLightPositions((prev) => {
      const newPositions = { ...prev };
      const currentPositions = [...(prev[String(lightId)]?.[data.channelNumber] || [])];

      if (data.isClone) {
        currentPositions.push({ top: boundedY, left: boundedX });
      } else {
        if (currentPositions[data.cloneIndex] !== undefined) {
          currentPositions[data.cloneIndex] = { top: boundedY, left: boundedX };
        } else {
          console.warn(`Invalid cloneIndex ${data.cloneIndex} for lightId=${lightId}, channelNumber=${data.channelNumber}`);
          currentPositions[0] = { top: boundedY, left: boundedX };
        }
      }

      newPositions[String(lightId)] = {
        ...prev[String(lightId)],
        [data.channelNumber]: currentPositions
      };

      fetch('https://trafficlight.saigoniot.vn/api/dpt/position', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lightId: lightId,
          channelNumber: data.channelNumber,
          positions: currentPositions.map(pos => ({ top: `${pos.top}`, left: `${pos.left}` }))
        })
      })
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          return response.json();
        })
        .then(result => {
          if (result.status === 'success') {
            setLightPositions(prevState => ({
              ...prevState,
              [String(lightId)]: {
                ...prevState[String(lightId)],
                [data.channelNumber]: currentPositions
              }
            }));
            console.log(`Position updated for lightId=${lightId}`);
          } else {
            console.warn('Failed to save position:', result.message);
            alert('Lưu vị trí thất bại! Vui lòng kiểm tra định dạng.');
          }
        })
        .catch(err => {
          console.error('Error saving position:', err.message);
          alert('Lỗi khi lưu vị trí: ' + err.message);
          setLightPositions(prev => ({
            ...prev,
            [String(lightId)]: {
              ...prev[String(lightId)],
              [data.channelNumber]: currentPositions
            }
          }));
        });

      return newPositions;
    });
  };

  // Cho phép thả
  const handleDragOver = (e) => {
    e.preventDefault();
    console.log('Drag over container');
  };

  // Mở modal khi chuột phải
  const handleContextMenu = (e, lightId) => {
    e.preventDefault();
    setSelectedLightId(lightId);
    setNewImageUrl(lightPositions[lightId]?.intersectionImage || 'https://trafficlight.saigoniot.vn/intersection.jpg');
    setModalOpen(true);
  };

  // Lưu hình ảnh mới
  const handleSaveImage = async () => {
    if (!selectedLightId || !newImageUrl) {
      alert('Vui lòng nhập URL hình ảnh hợp lệ!');
      return;
    }

    try {
      console.log(`Saving new image for lightId=${selectedLightId}, url=${newImageUrl}`);
      const response = await fetch('https://trafficlight.saigoniot.vn/api/dpt/position', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lightId: selectedLightId,
          intersectionImage: newImageUrl
        })
      });
      const result = await response.json();
      console.log('POST /api/dpt/position response:', JSON.stringify(result, null, 2));
      if (result.status === 'success') {
        const refreshResponse = await fetch('https://trafficlight.saigoniot.vn/api/dpt/position', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        const refreshData = await refreshResponse.json();
        if (refreshData.status === 'success') {
          setLightPositions(refreshData.data);
          setModalOpen(false);
          setNewImageUrl('');
        }
      } else {
        console.warn('Failed to save image:', result.message);
        alert('Cập nhật hình ảnh thất bại!');
      }
    } catch (err) {
      console.error('Error saving image:', err.message);
      alert('Lỗi khi cập nhật hình ảnh!');
    }
  };

  return (
    <div className="relative listLight">
      <style>
        {`

          .intersection-container {
            position: relative;
            width: 200px;
            height: 200px;
            margin: 0 auto;
            border: 1px solid #ccc;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
          .light-circle {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #000;
            cursor: move;
            position: absolute;
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
          .time-overlay {
            color: #fff;
            text-shadow: 0 0 2px #000;
            font-size: 10px;
          }
          .channel-container {
            display: flex;
            justify-content: center;
            gap: 8px;
            margin: 16px 0;
          }
          .edit-button {
            background-color: #4CAF50;
            color: white;
            border: none;
            padding: 5px;
            border-radius: 50%;
            cursor: pointer;
            margin-top: 8px;
          }
          .edit-button:hover {
            background-color: #45a049;
          }
      
          .modal-input {
            width: 80%;
            padding: 8px;
            margin: 10px 0;
            border: 1px solid #ccc;
            border-radius: 4px;
          }
          .modal-buttons {
            margin-top: 15px;
          }
          .modal-button {
            padding: 8px 16px;
            margin: 0 5px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .save-button {
            background-color: #4CAF50;
            color: white;
          }
          .save-button:hover {
            background-color: #45a049;
          }
          .cancel-button {
            background-color: #f44336;
            color: white;
          }
          .cancel-button:hover {
            background-color: #da190b;
          }
        `}
      </style>      
      {viewMode === 'list' ? (
        <div className="bg-white rounded shadow">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Chọn</th>
                <th className="border p-2">Trạng thái</th>
                <th className="border p-2">Chế độ</th>
                <th className="border p-2">Chức năng</th>
              </tr>
            </thead>
            <tbody align="center">
              {filteredLights.map((light) => {
                console.log(`Rendering light ${light.id}:`, JSON.stringify(light, null, 2));
                const channelColors = getLightStatus(light);
                return (
                  <tr key={light.id}>
                    <td className="border p-2 text-left">
                      <label htmlFor={`checkbox-${light.id}`}>
                        [{light.id}] {light.name || 'N/A'}
                      </label>
                      <input
                        type="checkbox"
                        id={`checkbox-${light.id}`}
                        checked={selectedLights.some((selected) => selected.id === light.id)}
                        onChange={() => handleSelectLight(light)}
                        className="ml-2"
                      />
                    </td>
                    <td className="border p-2 flex flex-col items-center justify-right gap-1">
                      {light.activeChannel && Array.isArray(light.activeChannel) && light.activeChannel.length > 0 ? (
                        light.activeChannel.map((channel, index) => (
                          <div key={channel.channelNumber} className="flex items-center gap-2">
                            <span>{channel.channelName}:</span>
                            <span
                              className="light-circle w-6 h-6 rounded-full"
                              style={{ backgroundColor: colorMap[light.onlineStatus === 'Offline' ? 'unknown' : channelColors[index]] || colorMap.red }}
                              title={channel.channelName}
                            >
                              <span className="time-overlay">{channel.channelNumber}</span>
                            </span>
                          </div>
                        ))
                      ) : (
                        <span>Không có dữ liệu kênh (ID: {light.id})</span>
                      )}
                      <span className="text-xs justify-ccenter">{getCurrentChannelName(light)}</span>
                    </td>
                    <td className="border p-2">
                      <div className="flex flex-col items-center gap-1">
                        <span>{light.control_mode ? 'Thủ công' : 'Tự động'}</span>
                        <span
                          className="light-circle w-6 h-6 rounded-full relative"
                          style={{ backgroundColor: colorMap[light.onlineStatus === 'Offline' ? 'unknown' : light.current_status] || colorMap.red }}
                        >
                          <span className="time-overlay">{light.time_remaining || 'N/A'}</span>
                        </span>
                        <small className="block">{light.onlineStatus}</small>
                      </div>
                    </td>
                    <td className="border p-2">
                      <div className="flex justify-center space-x-2">
                        <button
                          onClick={() => onEdit(light)}
                          className="bg-yellow-500 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-yellow-600"
                          title="Sửa"
                        >
                          <i className="material-icons" style={{ fontSize: '16px' }}>edit</i>
                        </button>
                        <button
                          onClick={() => onControlSingle(light)}
                          className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-blue-600"
                          title="Điều khiển"
                        >
                          <i className="material-icons" style={{ fontSize: '16px' }}>settings</i>
                        </button>
                        <button
                          onClick={() => onDelete(light.id)}
                          className="bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-red-600 hidden"
                          title="Xóa"
                        >
                          <i className="material-icons" style={{ fontSize: '16px' }}>delete</i>
                        </button>
                        <Link
                          to={`/traffic-light-detail/${light.id}`}
                          className="bg-green-500 text-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-green-600"
                          title="Chi tiết"
                        >
                          <i className="material-icons" style={{ fontSize: '16px' }}>info</i>
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="grid-view">
          {filteredLights.map((light) => {
            console.log(`Rendering light ${light.id} in grid view:`, JSON.stringify(light, null, 2));
            const channelColors = getLightStatus(light);
            return (
              <div
                key={light.id}
                className="traffic-light-card"
              >
                <div className="flex items-center justify-between">
                  <label htmlFor={`checkbox-${light.id}`} className="font-semibold whitespace-nowrap overflow-hidden text-ellipsis max-w-[150px]" title={light.name}>
                    [{light.id}] {light.name || 'N/A'}
                  </label>
                  <input
                    type="checkbox"
                    id={`checkbox-${light.id}`}
                    checked={selectedLights.some((selected) => selected.id === light.id)}
                    onChange={() => handleSelectLight(light)}
                    className="ml-2"
                  />
                </div>
                <div
                  className="intersection-container"
                  style={{ backgroundImage: `url(${light.intersectionImage || 'https://trafficlight.saigoniot.vn/intersection.jpg'})` }}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, light.id)}
                  onContextMenu={(e) => handleContextMenu(e, light.id)}
                >
                  {light.activeChannel && Array.isArray(light.activeChannel) && light.activeChannel.length > 0 ? (
                    light.activeChannel.flatMap((channel, index) =>
                      (lightPositions[String(light.id)]?.[String(channel.channelNumber)] || []).map((pos, cloneIndex) => (
                        <span
                          key={`${channel.channelNumber}-${cloneIndex}`}
                          className="light-circle"
                          draggable="true"
                          onDragStart={(e) => handleDragStart(e, light.id, channel.channelNumber, cloneIndex)}
                          style={{
                            backgroundColor: colorMap[light.onlineStatus === 'Offline' ? 'unknown' : channelColors[index]] || colorMap.red,
                            top: getChannelPosition(light, channel, cloneIndex).top,
                            left: getChannelPosition(light, channel, cloneIndex).left
                          }}
                          title={channel.channelName}
                        >
                          <span className="time-overlay">{channel.channelNumber}</span>
                        </span>
                      ))
                    )
                  ) : (
                    <span className="text-center block">Không có dữ liệu kênh (ID: {light.id})</span>
                  )}
                </div>
                <div className="flex flex-col items-center gap-1">
                  <span className="text-xs">{getCurrentChannelName(light)}</span>
                </div>
                <div className="flex justify-between items-center space-x-2 mt-2">
                  <div className="flex space-x-2">
                    <button
                      onClick={() => onEdit(light)}
                      className="bg-yellow-500 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-yellow-600"
                      title="Sửa"
                    >
                      <i className="material-icons" style={{ fontSize: '16px' }}>edit</i>
                    </button>
                    <button
                      onClick={() => onControlSingle(light)}
                      className="bg-blue-500 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-blue-600"
                      title="Điều khiển"
                    >
                      <i className="material-icons" style={{ fontSize: '16px' }}>settings</i>
                    </button>
                    <button
                      onClick={() => onDelete(light.id)}
                      className="bg-red-500 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-red-600 hidden"
                      title="Xóa"
                    >
                      <i className="material-icons" style={{ fontSize: '16px' }}>delete</i>
                    </button>
                    <Link
                      to={`/traffic-light-detail/${light.id}`}
                      className="bg-green-500 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-green-600"
                      title="Chi tiết"
                    >
                      <i className="material-icons" style={{ fontSize: '16px' }}>info</i>
                    </Link>
                  </div>
                  <button
                    className="bg-green-900 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-green-600 "
                    onClick={() => {
                      setSelectedLightId(light.id);
                      setNewImageUrl(light.intersectionImage);
                      setModalOpen(true);
                    }}
                    title="Chỉnh sửa hình ảnh"
                  >
                    <i className="material-icons" style={{ fontSize: '16px' }}>add_location_alt</i>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedLights.length > 0 && (
        <button
          onClick={handleBatchControl}
          className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-500 text-white px-6 py-3 rounded hover:bg-blue-600 shadow-lg z-50"
          style={{ minWidth: '250px', transition: 'all 0.3s ease' }}
        >
          Điều khiển ưu tiên tuyến đường ({selectedLights.length} đèn)
        </button>
      )}

      {modalOpen && (
        <div className="modal">
          <div className="modal-content">
            <div className="bg-blue-500 text-white p-2 rounded-t-lg">
              <h3 className="text-lg font-semibold mb-0">Chỉnh sửa hình ảnh nền (Đèn ID: {selectedLightId})</h3>
            </div>            
            <div className="modal-body">
              <input
                type="text"
                className="modal-input"
                value={newImageUrl}
                onChange={(e) => setNewImageUrl(e.target.value)}
                placeholder="Nhập URL hình ảnh mới"
              />
              <div className="modal-buttons">
                <button className="modal-button save-button" onClick={handleSaveImage}>
                  Lưu
                </button>
                <button
                  className="modal-button cancel-button"
                  onClick={() => {
                    setModalOpen(false);
                    setNewImageUrl('');
                  }}
                >
                  Hủy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrafficLightList;

// chạy 1 file position